module.exports = __webpack_public_path__ + "img/Group-1402.da65339f.png";